import { gsap } from 'gsap';

export default {
  props: {
    duration: Number,
  },
  template: '<transition :css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave" @after-leave="afterLeave"><slot></slot></transition>',
  methods: {
    beforeEnter(el) {
      el.style.opacity = '0';
    },
    enter(el, done) {
      gsap.to(el, this.duration, {
        opacity: 1,
        onComplete() {
          done();
        },
      });
    },
    leave(el, done) {
      el.style.opacity = '0';
      gsap.to(el, this.duration, {
        opacity: 0,
        position: 'absolute',
        onComplete() {
          done();
        },
      });
    },
    afterLeave(el) {
      el.style.position = null;
      el.style.opacity = null;
    },
  },
};



// WEBPACK FOOTER //
// ./core/animation/fade/animation-fade.js